export type TankBody = 'classic' | 'heavy' | 'light' | 'howitzer';
export type TankDecal = 'none' | 'star' | 'skull' | 'stripes' | 'flame' | 'target';

/** Vzhled tanku – čistě kosmetika, na hru nemá vliv. */
export interface TankLook {
  body: TankBody;
  color: string;
  accent: string;
  decal: TankDecal;
  /** Verze nahraného obrázku (timestamp); chybí = bez obrázku. */
  emblem?: number;
}

export const TANK_BODIES: { id: TankBody; name: string }[] = [
  { id: 'classic', name: 'Klasik' },
  { id: 'heavy', name: 'Těžký' },
  { id: 'light', name: 'Lehký' },
  { id: 'howitzer', name: 'Houfnice' },
];

export const TANK_DECALS: { id: TankDecal; name: string }[] = [
  { id: 'none', name: 'Bez' },
  { id: 'star', name: 'Hvězda' },
  { id: 'skull', name: 'Lebka' },
  { id: 'stripes', name: 'Pruhy' },
  { id: 'flame', name: 'Plameny' },
  { id: 'target', name: 'Terč' },
];

export const DEFAULT_LOOK: TankLook = { body: 'classic', color: '#e74c3c', accent: '#ffe08a', decal: 'none' };

const HEX = /^#[0-9a-f]{6}$/i;

export function sanitizeLook(input: unknown): TankLook | null {
  if (!input || typeof input !== 'object') return null;
  const o = input as Record<string, unknown>;
  if (!TANK_BODIES.some((b) => b.id === o.body)) return null;
  if (!TANK_DECALS.some((d) => d.id === o.decal)) return null;
  if (typeof o.color !== 'string' || !HEX.test(o.color)) return null;
  if (typeof o.accent !== 'string' || !HEX.test(o.accent)) return null;
  const look: TankLook = { body: o.body as TankBody, decal: o.decal as TankDecal, color: o.color.toLowerCase(), accent: o.accent.toLowerCase() };
  if (Number.isSafeInteger(o.emblem) && (o.emblem as number) > 0) look.emblem = o.emblem as number;
  return look;
}

export type BotLevel = 'easy' | 'normal' | 'hard';

export const BOT_LEVELS: { id: BotLevel; name: string }[] = [
  { id: 'easy', name: 'Nováček' },
  { id: 'normal', name: 'Voják' },
  { id: 'hard', name: 'Sniper' },
];

export function isBotLevel(v: unknown): v is BotLevel {
  return v === 'easy' || v === 'normal' || v === 'hard';
}

export type EmoteId = 'blink' | 'flare' | 'smoke' | 'firework' | 'hop' | 'wave';

export const EMOTES: { id: EmoteId; icon: string; name: string }[] = [
  { id: 'blink', icon: '💡', name: 'Blikat' },
  { id: 'flare', icon: '🎆', name: 'Světlice' },
  { id: 'smoke', icon: '💨', name: 'Zadýmit' },
  { id: 'firework', icon: '🎉', name: 'Ohňostroj' },
  { id: 'hop', icon: '🦘', name: 'Poskočit' },
  { id: 'wave', icon: '👋', name: 'Zamávat' },
];

export function isEmote(v: unknown): v is EmoteId {
  return EMOTES.some((e) => e.id === v);
}

/** Sloučí bílé znaky do jedné mezery a ořízne okraje. */
export function normalizeChat(text: string): string {
  return text.replace(/\s+/g, ' ').trim();
}

export const CHAT_MAX = 200;
export const BUBBLE_MAX = 30;
